import { createFileRoute } from "@tanstack/react-router";

import UsageAdmin from "@/components/UsageAdmin";

// Generated to match `src/app/admin/usage/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/usage")({
  component: UsageAdmin,
});
